import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { map, filter } from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { unicodeToString } from "../../../Js/Common";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import AudioButton from "../../../Components/Media/AudioButton";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import IconButton from "@mui/material/IconButton";
import PauseIcon from "@mui/icons-material/Pause";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const OO = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [isPlaying, setIsPlaying] = useState(false);
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (props.content) {
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill([])
      );
      dispatch(currentAssetSliceActions.setCurrentAttemptData([]));
      //console.log("#$#$#$",);
      let actualAnswers = [];
      for (let x = 0; x < props.content.epage.options.content.length; x++) {
        let childNodes = [];
        let ans = [];
        let index = 0;
        if (document.getElementById(`${x}_ansTextId`)) {
          childNodes = document
            .getElementById(`${x}_ansTextId`)
            .getElementsByTagName("span")[0].parentNode.childNodes;
          for (let x = 0; x < childNodes.length; x++) {
            if (childNodes[x]["textContent"].trim().length > 0) {
              let splitArr = childNodes[x]["textContent"]
                .trim()
                .match(/[a-zA-Z_0-9-$-'-’-]+|[^\s\w]+/g);
              //.split(" ");
              splitArr.map((val) => {
                if (
                  childNodes[x]["nodeName"] &&
                  childNodes[x]["nodeName"].toUpperCase() == "SPAN"
                ) {
                  ans.push({ index: index, status: true });
                } else {
                  ans.push({ index: index, status: false });
                }
                index++;
              });
            }
          }
        }
        actualAnswers.push(map(filter(ans, { status: true }), "index"));
      }

      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  }, [logObj]);

  useEffect(() => {
    setUserAnswer(
      new Array(props.content.epage.options.content.length).fill([])
    );
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(currentAssetSliceActions.setCurrentAttemptData([]));
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      setUserAnswer(assetLogObj.actualAnswer);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const updateUserAnswer = (index, innerIndex) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      let innerArray = newArray[index].map((item, i) => {
        return item;
      });
      let pos = innerArray.indexOf(innerIndex);
      if (pos == -1) {
        innerArray.push(innerIndex);
      } else {
        innerArray.splice(pos, 1);
      }
      newArray[index] = [...innerArray];
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData([...newArray]));
    }
  };

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <div>
      {props.content &&
        props.content.epage.options.content &&
        props.content.epage.options.content.map((val, index) => {
          return (
            <Box>
              <Grid sx={{ mt: 0, p: 1 }}>
                {val && val.media && (
                  <OptionMedia
                    media={val.media}
                    isPlaying={currentIndexPlay[index]}
                    setPlayMode={(status, end) => {
                      setPlayMode(status, index, end);
                    }}
                  ></OptionMedia>
                )}
              </Grid>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent:
                    props.content.epage.options.content.length == 1
                      ? "space-evenly"
                      : "flex-start",
                  border: 1,
                  borderColor: "#D9D9D9",
                  color: "primary.main",
                  borderRadius: 10,
                  boxShadow: 0,
                  cursor: "pointer",
                  py: 2,
                  pl: props.content.epage.options.content.length == 1 ? 0 : 2,
                  "@media (min-width: 1636px)": {
                    mt: 15,
                  },
                }}
              >
                <Grid
                  item
                  sx={{
                    ml: 1,
                    cursor: "pointer",
                  }}
                >
                  {optionWiseAns && optionWiseAns.length > 0 && (
                    <StatusIndicator
                      correct={optionWiseAns[index]}
                    ></StatusIndicator>
                  )}
                  <div
                    className="font_1_6"
                    style={{
                      fontWeight: "500",
                      fontSize: "1rem",
                      display: "inline-block",
                    }}
                  >
                    {unicodeToString(val["text"])
                      .replace(/<\/?div[^>]*>/g, "")
                      .replace(/<\/?p[^>]*>/g, "")
                      .replace(/<\/?span[^>]*>/g, "")
                      .replace(/<\/?br[^>]*>/g, "")
                      .replace(/&nbsp;/g, " ")
                      .replace(/\n/g, " ")
                      .match(/[a-zA-Z_0-9-$-'-’-]+|[^\s\w]+/g)
                      //.split(" ")
                      .map((valInner, ind) => {
                        return (
                          <span
                            style={{
                              display: "inline-block",
                              lineHeight: "1.6",
                              margin: "0px 3px",
                              borderBottomStyle:
                                userAnswer[index] &&
                                userAnswer[index].indexOf(ind) > -1
                                  ? "solid"
                                  : "none",
                              borderBottomColor:
                                userAnswer[index] &&
                                userAnswer[index].indexOf(ind) > -1
                                  ? "#DB8829"
                                  : "#FFFFFF",
                              fontWeight:
                                userAnswer[index] &&
                                userAnswer[index].indexOf(ind) > -1
                                  ? "bold"
                                  : "500",
                            }}
                            onClick={() => {
                              updateUserAnswer(index, ind);
                            }}
                          >
                            {valInner}
                          </span>
                        );
                      })}
                  </div>
                  <div
                    style={{ display: "none" }}
                    dangerouslySetInnerHTML={{
                      __html: unicodeToString(val["text"]),
                    }}
                    id={`${index}_ansTextId`}
                  ></div>
                  {showAnswer && val?.showmedia?.audio && (
                    <Grid style={{ display: "inline-block" }}>
                      <AudioButton
                        expertAudio={val["showmedia"]["audio"]}
                        playStatus={(status) => setIsPlaying(status)}
                      >
                        <IconButton
                          size="small"
                          sx={{
                            color: "#FFFFFF",
                            backgroundColor: "#DB8829",
                            mx: 1,
                            padding: 0,
                          
                          }}
                        >
                          {isPlaying && (
                            <PauseIcon
                              sx={{
                                borderRadius: "50%",
                                padding: 1,
                                color: "#FFFFFF",
                                "@media (min-width: 1636px)": {
                                  fontSize: "2.2rem",
                                },
                              }}
                            />
                          )}
                          {!isPlaying && (
                            <MusicNoteIcon
                              sx={{
                                borderRadius: "50%",
                                padding: 1,
                                "@media (min-width: 1636px)": {
                                  fontSize: "2.2rem",
                                },
                              }}
                            />
                          )}
                        </IconButton>
                      </AudioButton>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Box>
          );
        })}
    </div>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default OO;
